import { useState, useCallback } from "react"

import { CreateAddressResponse, CreateAddressRequest } from "@lib/clients/nelo-api-client"
import { medusaClient } from "@lib/config"
import { neloApiClient } from "@lib/config-client"

export const useUpdateAddress = () => {
  const [updatedAddress, setUpdatedAddress] = useState<CreateAddressResponse | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  const submitAddress = useCallback(async (cartId: string, addressRequest: CreateAddressRequest) => {
    setIsLoading(true)
    try {
      const response = await neloApiClient.createAddress(addressRequest)

      const splitName = response.address.addressedTo?.split(" ") || []
      const firstName = splitName.shift()
      const lastName = splitName.pop()

      await medusaClient.carts.update(cartId, {
        shipping_address: {
          postal_code: response.address.postalCode,
          province: response.address.colony,
          country_code: "mx",
          city: response.address.city,
          address_1: `${response.address.street} ${response.address.buildingNumber}`.trim(),
          address_2: response.address.interiorNumber,
          first_name: firstName,
          last_name: lastName,
          metadata: {
            instructions: response.address.deliveryInstructions || "",
            reference: response.address.reference,
          },
        },
      })
      setUpdatedAddress(response)
      return response
    } catch (err) {
      setError(err instanceof Error ? err : new Error("An unknown error occurred"))
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { submitAddress, updatedAddress, isLoading, error }
}
